import React from 'react';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import { Col, Row } from 'tea-component';
import Table from './Table';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import Visualis from './Visualis';
import { PAGE_TYPE_AGE, PAGE_TYPE_GENDER } from '../../_config/constant';
import GenderRatioChart from '../GenderRatioChart';

const AgeBreakdown = (props: any) => {
  const {
    tableData = [],
    lineData,
    tableHeaderOptions,
    cardStatus,
    dateType,
    startDate,
    endDate,
    pageType,
    barOrPieData,
    chartType,
    setChartType,
    chartCardTitle,
    cardTitle,
    pageSortAttr,
    onTableSortChage,
    disableChartType,
    rangeTimeType,
    disableSort,
  } = props;

  // const [chartType, setChartType] = useState(defaultChartIcon);
  const { isLoading, isError, isNoData } = cardStatus || {};

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        iconList={[]}
        className="dbi-mobileGames-card-context"
        // title={formatMessage({ id: `dbi_detail_trend` })}
        title={cardTitle}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  const genderPie = pageType === PAGE_TYPE_GENDER && chartType === 'pie';
  const isAgePage = pageType === PAGE_TYPE_AGE;

  return (
    <CardSlotV2
      title={cardTitle}
      activeTab={chartType}
      className="dbi-detail-card"
      disableChartType={disableChartType}
      getChange={(value: any) => {
        setChartType(value);
      }}
    >
      <div style={{ marginBottom: isAgePage ? 20 : 0 }}>
        <Row>
          <Col span={genderPie ? 12 : 24}>
          <div className="dbi-detail-card-chart">
            <Visualis
              pieData={barOrPieData}
              middleTitle={chartCardTitle}
              chartType={chartType}
              lineData={lineData}
              barData={lineData}
              dateType={dateType}
              startDate={startDate}
              endDate={endDate}
              pageType={pageType}
              rangeTimeType={rangeTimeType}
              lengendKeys={tableHeaderOptions?.map((item: any) => {
                return item?.value;
              })}
            />
          </div>
        </Col>
        {genderPie ? (
          <Col span={12}>
            <div className="dbi-detail-card-chart">
              {tableHeaderOptions?.map((item: any) => {
                const dataItem = barOrPieData.find((t: any) => {
                  return t?.metric === item?.value;
                });
                return (<>
                  <div style={{ whiteSpace: 'nowrap' }}>
                    <GenderRatioChart
                      percentage={dataItem?.value || 0}
                      maleType={item?.value}
                    />
                  </div>
                  <div style={{ width: '100%' }}></div>
                </>
                );
              })}
            </div>
          </Col>
        ) : (
          <Col span={0}></Col>
        )}
        </Row>
      </div>

      <Table
        dateType={dateType}
        tableData={tableData}
        tableHeaderOptions={tableHeaderOptions}
        pageType={pageType}
        pageSortAttr={pageSortAttr}
        onTableSortChage={onTableSortChage}
        rangeTimeType={rangeTimeType}
        startDate={startDate}
        endDate={endDate}
        disableSort={disableSort}
      />
    </CardSlotV2>
  );
};

export default AgeBreakdown;
